(function () {
  if (!window.Shopify || !Shopify.customerPrivacy) return;

  function applyConsent(consent) {
    try {
      Shopify.customerPrivacy.setTrackingConsent(
        {
          analytics: !!consent.analytics,
          marketing: !!consent.marketing,
          preferences: !!consent.preferences,
          sale_of_data: !!consent.sale_of_data
        },
        function () {
          document.dispatchEvent(
            new CustomEvent("shopify:privacy:consent-updated", {
              detail: consent
            })
          );
        }
      );
    } catch (e) {}
  }

  function getStoredConsent() {
    try {
      return JSON.parse(localStorage.getItem("shopify_consent"));
    } catch (e) {
      return null;
    }
  }

  function storeConsent(consent) {
    localStorage.setItem("shopify_consent", JSON.stringify(consent));
  }

  document.addEventListener("DOMContentLoaded", function () {
    var existing = getStoredConsent();

    if (existing) {
      applyConsent(existing);
    } else {
      Shopify.customerPrivacy.getTrackingConsent(function (consent) {
        storeConsent(consent);
        applyConsent(consent);
      });
    }
  });

  window.setShopifyConsent = function (consent) {
    storeConsent(consent);
    applyConsent(consent);
  };
})();
